import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Web-specific hook for handling navigation on Favorites page.
 * Encapsulates React Router navigation logic.
 */
export function useFavoritesNavigation() {
  const navigate = useNavigate();

  const navigateToTrip = useCallback(
    (url: string) => {
      navigate(url);
    },
    [navigate],
  );

  return {
    navigateToTrip,
  };
}
